// covered-by: packages/schemas/src/christo/__tests__/askPunttArea.test.ts
import { z } from "zod";

/**
 * The closed set of areas of work a project member can own.
 *
 * why one shared list: a review finding is filed under an area, and a project
 * member is named as the owner of an area. Routing an ask to a person is then a
 * lookup, not a guess. Python also needs the list (rembrandt picks the owner),
 * so the values live in `askPunttAreas.json` and the JSON is the single source
 * of truth. TypeScript imports it; Python COPIES it into `areas.py` rather than
 * reading it at import time, because the service container ships without a repo
 * root and a file read at import would fail in production. The copy is kept
 * honest from both sides: `askPunttArea.test.ts` fails if this tuple drifts
 * from the JSON, and `test_ask_puntt_area_parity.py` fails if Python does.
 *
 * The six review domains are warhol's `ReviewerDomain` — the tags its reviewer
 * puts on a finding, and the ones the wire already carries. `brand` is the
 * seventh: brand and copy judgement that no single reviewer owns. Decision 5
 * (Adam, 2026-10-07) fixed this list.
 */
export const ASK_PUNTT_AREAS = [
  "regulated-copy",
  "nutrition",
  "codes-values",
  "completeness",
  "variants",
  "copy-diff",
  "brand",
] as const;

export type AskPunttArea = (typeof ASK_PUNTT_AREAS)[number];

export const askPunttAreaSchema = z.enum(ASK_PUNTT_AREAS);

/** True when `value` is one of the closed set of areas. */
export function isAskPunttArea(value: unknown): value is AskPunttArea {
  return (
    typeof value === "string" &&
    (ASK_PUNTT_AREAS as readonly string[]).includes(value)
  );
}
